/* HomLoom COD Form - "thank you" screen (v2 compact, 02 Nov 2026)
   Brand bar, confirmation, order summary, 3 next steps, reminder, WhatsApp, 3 best sellers, brand footer + socials.
   Reads the order the form just sent (hl-cod.js) - no change to how orders are placed. */
(function () {
  var root = document.getElementById('hl-cod');
  if (!root || root.__hlthanks) return;
  root.__hlthanks = 1;

  var SOCIAL = {
    instagram: 'https://www.instagram.com/homl.oom/',
    facebook: 'https://www.facebook.com/profile.php?id=61592344344051',
    tiktok: ''
  };
  var LOGO = 'https://www.homloom.store/cdn/shop/files/homloom_logo.png?width=120';

  var cfg = {};
  try { cfg = JSON.parse(document.getElementById('hl-cod-config').textContent); } catch (e) {}
  var MF = cfg.moneyFormat || 'Dhs. {{amount}}';
  function fmt(c) {
    var a = (c / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return MF.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, a);
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function q(s, el) { return (el || root).querySelector(s); }
  function isAr() { return root.getAttribute('data-lang') === 'ar'; }

  var AR = {
    'Order confirmed': 'تم تأكيد الطلب',
    'Thank you': 'شكراً لك',
    'Your order': 'طلبك',
    'is booked. Pay': 'تم حجزه. ادفع',
    'at your door.': 'عند الباب.',
    'Order summary': 'ملخص الطلب',
    'Qty': 'الكمية',
    'Shipping Protection': 'حماية الشحن',
    'Mystery Box': 'صندوق المفاجآت',
    '2-Day Delivery': 'توصيل خلال يومين',
    'Delivery': 'التوصيل',
    'FREE': 'مجاناً',
    'Cash on Delivery': 'الدفع عند الاستلام',
    'To pay at your door': 'المبلغ عند الاستلام',
    'What happens next?': 'ماذا بعد؟',
    'Order received': 'تم استلام الطلب',
    'Quick call / WhatsApp': 'اتصال أو واتساب سريع',
    'No call - we deliver': 'بدون اتصال - نوصل مباشرة',
    'At your door': 'عند بابك',
    'days': 'أيام',
    'Please check your details': 'يرجى التأكد من بياناتك',
    'Wrong? Tell us on WhatsApp': 'خطأ؟ أخبرنا عبر واتساب',
    'WhatsApp us': 'راسلنا واتساب',
    'Keep shopping': 'متابعة التسوق',
    'Customers also love': 'الأكثر طلباً',
    'Follow us': 'تابعنا'
  };
  var H = window.hlcAR || {};
  for (var k in AR) H[k] = AR[k];
  function T(en) { return isAr() && AR[en] ? AR[en] : en; }

  var QUOTE = { en: 'Home is where your story lives. Fill it with things you love.', ar: 'البيت هو المكان الذي تعيش فيه قصتك. املأه بما تحب.' };
  var BRAND = {
    en: 'Thoughtful home & kitchen essentials for homes across the UAE - fast delivery, pay at your door.',
    ar: 'مستلزمات منزل ومطبخ مختارة بعناية لكل البيوت في الإمارات - توصيل سريع والدفع عند الاستلام.'
  };

  /* ---------- remember the order the form sends ---------- */
  var last = null;
  var origFetch = window.fetch;
  window.fetch = function (u, o) {
    var p = origFetch.apply(this, arguments);
    try {
      if (/workers\.dev\/order/.test(String(u)) && o && o.body) {
        var body = JSON.parse(o.body);
        if (!body.quoteOnly) {
          var cartP = body.items ? origFetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).catch(function () { return null; }) : Promise.resolve(null);
          var tag = q('.hlc__tag.is-on');
          var offerTitle = tag ? (tag.querySelector('b') || tag).textContent.trim() : '';
          p.then(function (r) { return r.clone().json(); }).then(function (j) {
            if (!j || !j.ok || j.quote) return;
            cartP.then(function (cart) {
              last = { body: body, res: j, cart: cart, offer: offerTitle };
              if (doneEl && !doneEl.hidden) render();
            });
          }).catch(function () {});
        }
      }
    } catch (e) {}
    return p;
  };

  /* ---------- styles ---------- */
  var css = document.createElement('style');
  css.textContent = [
    '.hlc [data-hlc-done].hlct-on>:not(.hlct){display:none!important}',
    '.hlct{--tg:#5E614B;--tt:#B59573;--ti:#1C1C18;--tm:#4A433B;font-family:var(--f);color:var(--ti);text-align:start;padding:0 0 4px}',
    '.hlct *{box-sizing:border-box}',
    '.hlct p{margin:0}',
    '.hlct svg{width:15px;height:15px;fill:none;stroke:currentColor;stroke-width:1.9;stroke-linecap:round;stroke-linejoin:round}',
    /* brand bar */
    '.hlct__brandbar{display:flex;align-items:center;justify-content:center;gap:8px;padding:2px 0 10px}',
    '.hlct__brandbar img{width:34px;height:34px;object-fit:contain;mix-blend-mode:multiply}',
    '.hlct__brandbar b{font-family:Georgia,"Times New Roman",serif;font-size:22px;font-weight:400;letter-spacing:.3px;color:#3F4234}',
    '.hlct__brandbar b i{font-style:italic;color:var(--tt)}',
    /* hero */
    '.hlct__hero{display:flex;align-items:center;gap:12px;padding:12px 14px;border-radius:16px;background:linear-gradient(160deg,#F3EADB,#FBF8F3)}',
    '.hlct__tick{flex:0 0 42px;height:42px;border-radius:50%;background:var(--tg);color:#fff;display:flex;align-items:center;justify-content:center;box-shadow:0 0 0 5px rgba(94,97,75,.13)}',
    '.hlct__tick svg{width:22px;height:22px;stroke-width:2.6}',
    '.hlct__kicker{font-size:10px;font-weight:800;letter-spacing:1.1px;text-transform:uppercase;color:var(--tg)}',
    '.hlct__title{font-size:19px;line-height:1.2;font-weight:800}',
    '.hlct__sub{margin-top:2px!important;font-size:12.5px;line-height:1.4;color:var(--tm)}',
    '.hlct__sub b{color:var(--ti)}',
    /* cards */
    '.hlct__card{margin-top:10px;padding:11px 12px;border-radius:16px;background:#fff;border:1px solid #E7DECF}',
    '.hlct__h{display:flex;align-items:center;gap:7px;margin-bottom:8px!important;font-size:13.5px;font-weight:800}',
    '.hlct__h i{display:flex;width:24px;height:24px;border-radius:7px;background:#F2F3EC;color:var(--tg);align-items:center;justify-content:center;font-style:normal}',
    '.hlct__ono{margin-inline-start:auto;padding:2px 8px;border-radius:999px;background:#F2F3EC;font-size:11.5px;font-weight:800;color:var(--tg)}',
    '.hlct__item{display:flex;gap:10px;align-items:center;padding-bottom:8px;border-bottom:1px dashed #E2D8C8}',
    '.hlct__item+.hlct__item{padding-top:8px}',
    '.hlct__img{flex:0 0 46px;height:46px;border-radius:10px;background:#F4EFE7 center/cover no-repeat;border:1px solid #EDE5D8}',
    '.hlct__iname{font-size:13px;font-weight:700;line-height:1.25}',
    '.hlct__imeta{margin-top:1px!important;font-size:11.5px;color:var(--tm)}',
    '.hlct__rows{padding-top:5px}',
    '.hlct__row{display:flex;justify-content:space-between;gap:10px;padding:2px 0;font-size:12px;color:#3E3832}',
    '.hlct__row b{font-weight:700;color:var(--ti)}',
    '.hlct__free{color:#2E7D46!important}',
    '.hlct__total{display:flex;justify-content:space-between;align-items:center;margin-top:7px;padding:9px 11px;border-radius:11px;background:var(--tg);color:#fff}',
    '.hlct__total span{font-size:12px;font-weight:600;opacity:.92}',
    '.hlct__total b,.hlct__total b *{font-size:16px!important;font-weight:800!important;color:#fff!important}',
    /* steps (one row) */
    '.hlct__steps{display:grid;grid-template-columns:repeat(3,1fr);gap:6px;margin:0;padding:0;list-style:none;position:relative}',
    '.hlct__steps::before{content:"";position:absolute;top:15px;left:16%;right:16%;height:2px;background:#E2D8C8}',
    '.hlct__step{position:relative;display:flex;flex-direction:column;align-items:center;text-align:center;gap:4px}',
    '.hlct__dot{width:30px;height:30px;border-radius:50%;background:#fff;color:var(--tg);display:flex;align-items:center;justify-content:center;border:1.5px solid #D9D3C4}',
    '.hlct__step.is-done .hlct__dot{background:var(--tg);color:#fff;border-color:var(--tg)}',
    '.hlct__step b{font-size:11.5px;line-height:1.25}',
    '.hlct__step small{font-size:10.5px;line-height:1.25;color:var(--tm)}',
    /* reminder */
    '.hlct__remind{margin-top:10px;padding:9px 12px;border-radius:14px;background:#FFF8EC;border:1px solid #F0DDBE;font-size:12px;line-height:1.4;color:#4A3D2A}',
    '.hlct__remind b{display:block;margin-bottom:3px;font-size:12.5px;color:#5A3E14}',
    '.hlct__remind span{color:var(--ti)}',
    '.hlct__remind a{display:inline-block;margin-top:4px;font-size:11.5px;font-weight:700;color:#1E7E44!important;text-decoration:underline}',
    /* buttons */
    '.hlct__btns{display:grid;grid-template-columns:1.25fr 1fr;gap:8px;margin-top:10px}',
    '.hlct__btn{display:flex;align-items:center;justify-content:center;gap:7px;padding:11px 8px;border-radius:12px;border:0;font:800 13px/1 var(--f);cursor:pointer;text-decoration:none!important;white-space:nowrap}',
    '.hlct__btn--wa{background:#25D366;color:#fff!important;box-shadow:0 3px 0 #1DA851}',
    '.hlct__btn--wa svg{width:17px;height:17px;fill:currentColor;stroke:none}',
    '.hlct__btn--ghost{background:#fff;color:var(--ti)!important;border:1.5px solid #D9D3C4}',
    /* best sellers */
    '.hlct__ups{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:7px}',
    '.hlct__up{display:flex;flex-direction:column;border-radius:11px;border:1px solid #EDE5D8;background:#FCFAF6;overflow:hidden;text-decoration:none!important;color:var(--ti)!important}',
    '.hlct__up i{display:block;aspect-ratio:1/1;background:#F4EFE7 center/cover no-repeat}',
    '.hlct__up div{padding:5px 6px 6px}',
    '.hlct__up b{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;font-size:10.5px;line-height:1.25;min-height:26px}',
    '.hlct__up .pr,.hlct__up .pr *{display:block;margin-top:2px;font-size:11px!important;font-weight:800!important;color:var(--tg)!important}',
    /* footer */
    '.hlct__foot{margin-top:10px;padding:12px;border-radius:16px;background:#34372B;color:#F3EEE4;text-align:center}',
    '.hlct__quote{font-family:Georgia,"Times New Roman",serif;font-style:italic;font-size:13px;line-height:1.45}',
    '.hlct__brand{margin-top:6px!important;font-size:11px;line-height:1.45;opacity:.85}',
    '.hlct__socs{display:flex;justify-content:center;align-items:center;gap:8px;margin-top:9px}',
    '.hlct__socs span{font-size:10px;font-weight:700;letter-spacing:1px;text-transform:uppercase;opacity:.75;margin-inline-end:2px}',
    '.hlct__soc{display:flex;width:32px;height:32px;border-radius:50%;align-items:center;justify-content:center;background:#fff;color:#34372B!important}',
    '.hlct__soc svg{width:16px;height:16px}',
    '.hlct__soc--wa{background:#25D366;color:#fff!important}',
    '.hlct__soc--fb{background:#1877F2;color:#fff!important}',
    '.hlct__soc--wa svg,.hlct__soc--fb svg,.hlct__soc--tt svg{fill:currentColor;stroke:none}',
    /* beat the form's own .hlc__done p rules */
    '.hlc__done .hlct .hlct__title{font-size:19px!important;line-height:1.2!important}',
    '.hlc__done .hlct .hlct__sub{font-size:12.5px!important;line-height:1.4!important}',
    '.hlc__done .hlct .hlct__kicker{font-size:10px!important}',
    '.hlc__done .hlct .hlct__h{font-size:13.5px!important}',
    '.hlc__done .hlct .hlct__iname{font-size:13px!important}',
    '.hlc__done .hlct .hlct__imeta{font-size:11.5px!important}',
    '.hlc__done .hlct .hlct__quote{font-size:13px!important;color:#F3EEE4!important}',
    '.hlc__done .hlct .hlct__brand{font-size:11px!important;color:rgba(243,238,228,.88)!important}',
    '.hlc__done .hlct .hlct__remind,.hlc__done .hlct .hlct__remind p{font-size:12px!important}',
    '.hlct__total small{display:block;font-size:10.5px;font-weight:500;opacity:.85}',
    '.hlct__total b{white-space:nowrap}'
  ].join('');
  document.head.appendChild(css);

  var IC = {
    check: '<svg viewBox="0 0 24 24"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>',
    bag: '<svg viewBox="0 0 24 24"><path d="M5 8h14l-1 12H6zM9 8V6a3 3 0 0 1 6 0v2"/></svg>',
    phone: '<svg viewBox="0 0 24 24"><path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2"/></svg>',
    truck: '<svg viewBox="0 0 24 24"><path d="M2 6h12v10H2zM14 10h4l3 3v3h-7"/><circle cx="6" cy="18" r="2"/><circle cx="17" cy="18" r="2"/></svg>',
    home: '<svg viewBox="0 0 24 24"><path d="M3 11l9-7 9 7v9H3zM9 20v-6h6v6"/></svg>',
    star: '<svg viewBox="0 0 24 24"><path d="M12 3l2.7 5.6 6.1.9-4.4 4.3 1 6.1L12 17l-5.4 2.9 1-6.1L3.2 9.5l6.1-.9z"/></svg>',
    wa: '<svg viewBox="0 0 24 24"><path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm5.3 14.1c-.2.6-1.3 1.2-1.8 1.2-.5.1-1 .2-3.3-.7-2.8-1.1-4.5-4-4.7-4.2-.1-.2-1.1-1.5-1.1-2.9s.7-2 1-2.3c.2-.3.5-.3.7-.3h.5c.2 0 .4 0 .6.5l.8 2c.1.2.1.4 0 .5l-.4.6-.4.4c-.1.2-.3.3-.1.6.2.3.8 1.3 1.7 2.1 1.2 1 2.1 1.4 2.4 1.5.3.2.5.1.6-.1l.9-1c.2-.3.4-.2.6-.1l1.9.9c.3.1.5.2.5.3.1.2.1.7-.1 1.3z"/></svg>',
    ig: '<svg viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r=".8"/></svg>',
    fb: '<svg viewBox="0 0 24 24"><path d="M14 8h3V4h-3a4 4 0 0 0-4 4v3H7v4h3v6h4v-6h3l1-4h-4V8.5a.5.5 0 0 1 .5-.5z"/></svg>',
    tt: '<svg viewBox="0 0 24 24"><path d="M16.5 3c.4 2.2 1.9 3.8 4 4v3.2a7.6 7.6 0 0 1-4-1.3v6.4A5.7 5.7 0 1 1 10.8 9.6v3.3a2.5 2.5 0 1 0 2.5 2.5V3z"/></svg>'
  };

  function etaDays(cc) { return cc === 'AE' ? '2–3' : '3–5'; } // UAE 2-3 days, other GCC 3-5 days

  function lines() {
    var b = last.body, out = [];
    if (b.items && last.cart && last.cart.items && last.cart.items.length) {
      last.cart.items.forEach(function (it) {
        out.push({ img: it.image || '', name: it.product_title, meta: (it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title + ' · ' : '') + T('Qty') + ' ' + it.quantity });
      });
    } else {
      var p = cfg.product || {};
      var v = (p.variants || []).filter(function (x) { return x.id === b.variantId; })[0] || (p.variants || [])[0] || {};
      out.push({ img: v.image || p.image || '', name: p.title || '', meta: T('Qty') + ' ' + (b.quantity || 1) + (last.offer ? ' · ' + last.offer : '') + (v.title && v.title !== 'Default Title' ? ' · ' + v.title : '') });
    }
    return out;
  }

  function render() {
    if (!last || !doneEl) return;
    var ar = isAr();
    var b = last.body, j = last.res;
    var first = String(b.name || '').trim().split(/\s+/)[0];
    if (/^cod$/i.test(first)) first = '';
    var total = fmt(Math.round(Number(j.total || 0) * 100));
    var ad = b.addons || {};
    var orderNo = j.orderName || '';
    var wa = doneEl.querySelector('a[href*="wa.me"], a[href*="whatsapp"]');
    var waHref = wa ? wa.getAttribute('href') : (cfg.whatsapp ? 'https://wa.me/' + cfg.whatsapp + '?text=' + encodeURIComponent('Hi HomLoom, about my order ' + orderNo) : '');
    var waFix = cfg.whatsapp ? 'https://wa.me/' + cfg.whatsapp + '?text=' + encodeURIComponent('Hi HomLoom, I need to correct the details of my order ' + orderNo + '.') : waHref;

    var rows = '';
    if (b.protection) rows += '<div class="hlct__row"><span>' + T('Shipping Protection') + '</span><b>' + (cfg.protection ? fmt(cfg.protection.price) : '') + '</b></div>';
    if (ad.mysteryBox) rows += '<div class="hlct__row"><span>' + T('Mystery Box') + '</span><b>' + fmt(ad.mysteryBox.price) + '</b></div>';
    rows += ad.express2day
      ? '<div class="hlct__row"><span>' + T('2-Day Delivery') + '</span><b>' + fmt(ad.express2day.price) + '</b></div>'
      : '<div class="hlct__row"><span>' + T('Delivery') + '</span><b class="hlct__free">' + T('FREE') + '</b></div>';

    var addr = String(b.address || '').split(' | NOTE:')[0];
    var phone = '+' + ({ AE: '971', SA: '966', QA: '974', OM: '968', KW: '965', BH: '973' }[b.country] || '') + ' ' + (b.phone || '');
    var call = b.callPref === 'call';
    var days = ad.express2day ? '2' : etaDays(b.country);

    var socials = '';
    if (waHref) socials += '<a class="hlct__soc hlct__soc--wa" href="' + esc(waHref) + '" target="_blank" rel="noopener" aria-label="WhatsApp">' + IC.wa + '</a>';
    if (SOCIAL.instagram) socials += '<a class="hlct__soc" href="' + esc(SOCIAL.instagram) + '" target="_blank" rel="noopener" aria-label="Instagram">' + IC.ig + '</a>';
    if (SOCIAL.facebook) socials += '<a class="hlct__soc hlct__soc--fb" href="' + esc(SOCIAL.facebook) + '" target="_blank" rel="noopener" aria-label="Facebook">' + IC.fb + '</a>';
    if (SOCIAL.tiktok) socials += '<a class="hlct__soc hlct__soc--tt" href="' + esc(SOCIAL.tiktok) + '" target="_blank" rel="noopener" aria-label="TikTok">' + IC.tt + '</a>';

    var html =
      '<div class="hlct__brandbar"><img src="' + LOGO + '" alt="" width="34" height="34"><b>Hom<i>Loom</i></b></div>' +

      '<div class="hlct__hero">' +
        '<div class="hlct__tick">' + IC.check + '</div>' +
        '<div><p class="hlct__kicker">' + T('Order confirmed') + '</p>' +
        '<p class="hlct__title">' + T('Thank you') + (first ? ', ' + esc(first) : '') + '!</p>' +
        '<p class="hlct__sub">' + T('Your order') + ' <b>' + esc(orderNo) + '</b> ' + T('is booked. Pay') + ' <b>' + total + '</b> ' + T('at your door.') + '</p></div>' +
      '</div>' +

      '<div class="hlct__card">' +
        '<p class="hlct__h"><i>' + IC.bag + '</i>' + T('Order summary') + '<span class="hlct__ono">' + esc(orderNo) + '</span></p>' +
        lines().map(function (l) {
          return '<div class="hlct__item"><span class="hlct__img" style="background-image:url(\'' + esc(l.img) + '\')"></span><div><p class="hlct__iname">' + esc(l.name) + '</p><p class="hlct__imeta">' + esc(l.meta) + '</p></div></div>';
        }).join('') +
        '<div class="hlct__rows">' + rows + '</div>' +
        '<div class="hlct__total"><span>' + T('To pay at your door') + '<small>' + T('Cash on Delivery') + '</small></span><b>' + total + '</b></div>' +
      '</div>' +

      '<div class="hlct__card">' +
        '<p class="hlct__h"><i>' + IC.truck + '</i>' + T('What happens next?') + '</p>' +
        '<ol class="hlct__steps">' +
          '<li class="hlct__step is-done"><span class="hlct__dot">' + IC.check + '</span><b>' + T('Order received') + '</b></li>' +
          '<li class="hlct__step"><span class="hlct__dot">' + IC.phone + '</span><b>' + (call ? T('Quick call / WhatsApp') : T('No call - we deliver')) + '</b></li>' +
          '<li class="hlct__step"><span class="hlct__dot">' + IC.home + '</span><b>' + T('At your door') + '</b><small>' + days + ' ' + T('days') + '</small></li>' +
        '</ol>' +
      '</div>' +

      '<div class="hlct__remind"><b>' + T('Please check your details') + '</b>' +
        '<span>☎ ' + esc(phone) + '</span> · <span>⌂ ' + esc(addr) + '</span><br>' +
        (waFix ? '<a href="' + esc(waFix) + '" target="_blank" rel="noopener">' + T('Wrong? Tell us on WhatsApp') + ' →</a>' : '') +
      '</div>' +

      '<div class="hlct__btns">' +
        (waHref ? '<a class="hlct__btn hlct__btn--wa" href="' + esc(waHref) + '" target="_blank" rel="noopener">' + IC.wa + T('WhatsApp us') + '</a>' : '<span></span>') +
        '<button type="button" class="hlct__btn hlct__btn--ghost" data-hlct-continue>' + T('Keep shopping') + '</button>' +
      '</div>' +

      '<div class="hlct__card" data-hlct-ups hidden>' +
        '<p class="hlct__h"><i>' + IC.star + '</i>' + T('Customers also love') + '</p>' +
        '<div class="hlct__ups"></div>' +
      '</div>' +

      '<div class="hlct__foot">' +
        '<p class="hlct__quote">“' + (ar ? QUOTE.ar : QUOTE.en) + '”</p>' +
        '<p class="hlct__brand"><b>HomLoom</b> · ' + (ar ? BRAND.ar : BRAND.en) + '</p>' +
        (socials ? '<div class="hlct__socs"><span class="lbl">' + T('Follow us') + '</span>' + socials + '</div>' : '') +
      '</div>';

    var box = q('.hlct', doneEl);
    if (!box) { box = document.createElement('div'); box.className = 'hlct'; doneEl.appendChild(box); }
    box.setAttribute('dir', ar ? 'rtl' : 'ltr');
    box.innerHTML = html;
    doneEl.classList.add('hlct-on');
    if (!box.__drawn) { box.__drawn = 1; doneEl.scrollTop = 0; }
    loadUps(box);
  }

  /* 3 best-selling products the customer did not just order (Shopify best-selling order, this market) */
  var upsCache = null;
  function loadUps(box) {
    var wrap = q('[data-hlct-ups]', box);
    if (!wrap) return;
    var skip = /mystery|protection|gift/i;
    var bought = {};
    if (cfg.product && cfg.product.handle) bought[cfg.product.handle] = 1;
    ((last.cart && last.cart.items) || []).forEach(function (i) { bought[i.handle] = 1; });
    var cc = (last.body.country || 'AE').toUpperCase();
    var query = 'query Best @inContext(country: ' + cc + ') { products(first: 12, sortKey: BEST_SELLING) { nodes { handle title availableForSale featuredImage { url } priceRange { minVariantPrice { amount } } } } }';
    var get = upsCache ? Promise.resolve(upsCache) : fetch('/api/2025-01/graphql.json', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ query: query }) })
      .then(function (r) { return r.json(); }).then(function (j) { upsCache = (j && j.data && j.data.products && j.data.products.nodes) || []; return upsCache; });
    get.then(function (list) {
      list = list.filter(function (p) { return p.availableForSale && !bought[p.handle] && !skip.test(p.handle + ' ' + p.title); }).slice(0, 3);
      if (!list.length) return;
      q('.hlct__ups', wrap).innerHTML = list.map(function (p) {
        var img = p.featuredImage ? p.featuredImage.url + (p.featuredImage.url.indexOf('?') > -1 ? '&' : '?') + 'width=240' : '';
        var price = Math.round(parseFloat(p.priceRange.minVariantPrice.amount) * 100);
        return '<a class="hlct__up" href="/products/' + esc(p.handle) + '"><i style="background-image:url(\'' + esc(img) + '\')"></i><div><b>' + esc(p.title) + '</b><span class="pr">' + fmt(price) + '</span></div></a>';
      }).join('');
      wrap.hidden = false;
    }).catch(function () {});
  }

  /* ---------- show it when the form switches to "done" ---------- */
  var doneEl = q('[data-hlc-done]');
  if (!doneEl) return;
  root.addEventListener('click', function (e) {
    if (!e.target.closest('[data-hlct-continue]')) return;
    var orig = [].slice.call(doneEl.querySelectorAll('button, a')).filter(function (x) { return !x.closest('.hlct') && /continue/i.test(x.textContent || ''); })[0];
    if (orig) orig.click(); else { var x = q('[data-hlc-close]'); if (x) x.click(); }
  });
  new MutationObserver(function () {
    if (!doneEl.hidden && last && !q('.hlct', doneEl)) render();
    if (doneEl.hidden && q('.hlct', doneEl)) { doneEl.classList.remove('hlct-on'); var bx = q('.hlct', doneEl); bx.parentNode.removeChild(bx); }
  }).observe(doneEl, { attributes: true, attributeFilter: ['hidden'] });
  var lastLang = root.getAttribute('data-lang');
  new MutationObserver(function () { var l = root.getAttribute('data-lang'); if (l === lastLang) return; lastLang = l; if (!doneEl.hidden && last && q('.hlct', doneEl)) render(); }).observe(root, { attributes: true, attributeFilter: ['data-lang'] });

  // preview helper (theme preview only): open the form, then run hlcThanksDemo() in the console
  window.hlcThanksDemo = function () {
    var p = cfg.product || {}, v = (p.variants || [])[0] || {};
    last = { body: { name: 'Sara Ahmed', phone: '501234567', country: 'AE', address: 'Al Barsha, Villa 12, Street 5', callPref: 'call', variantId: v.id, quantity: 3, protection: true, addons: { mysteryBox: { price: 3000 }, express2day: null } }, res: { ok: true, orderName: '#1234', total: 178.99 }, cart: null, offer: 'Buy 2 & Get 1 Free' };
    root.hidden = false;
    doneEl.hidden = false;
    var f = q('#hlc-form'); if (f) f.hidden = true;
    render();
  };
})();
